import api from "./api";

// Organization
export const getOrg = () => api.get("/org").then((r) => r.data);
export const updateOrg = (data: { name?: string; industry?: string; logo_url?: string }) =>
  api.put("/org", data).then((r) => r.data);
export const getOrgMembers = () => api.get("/org/members").then((r) => r.data);

// RBAC
export const getRbacMe = () => api.get("/rbac/me").then((r) => r.data);

// User management (admin)
export const getAdminUsers = () => api.get("/admin/users").then((r) => r.data);
export const getAdminLeads = () => api.get("/admin/leads").then((r) => r.data);
export const setLeadStatus = (id: string, status: string) =>
  api.put(`/admin/leads/${id}/status`, { status }).then((r) => r.data);
export const setUserRole = (id: string, role: string) =>
  api.put(`/admin/users/${id}/role`, { role }).then((r) => r.data);
export const setUserBeta = (id: string, is_beta_tester: boolean) =>
  api.put(`/admin/users/${id}/beta`, { is_beta_tester }).then((r) => r.data);

// Audit
export const getAudit = () => api.get("/audit").then((r) => r.data);

// Outreach Center (admin)
export const getOutreach = () => api.get("/admin/outreach/prospects").then((r) => r.data);
export const seedOutreach = () => api.post("/admin/outreach/seed").then((r) => r.data);
export const importOutreach = (file: File) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/admin/outreach/import", fd).then((r) => r.data);
};
export const updateProspect = (id: string, data: Record<string, any>) =>
  api.put(`/admin/outreach/prospects/${id}`, data).then((r) => r.data);
export const getProspectLetter = (id: string) => api.get(`/admin/outreach/prospects/${id}/letter`).then((r) => r.data);
export const sendProspectLetter = (id: string, data: Record<string, any>) =>
  api.post(`/admin/outreach/prospects/${id}/send`, data).then((r) => r.data);
export const getOutreachEmailHealth = () => api.get("/admin/outreach/email-health").then((r) => r.data);
export const getOutreachSettings = () => api.get("/admin/outreach/settings").then((r) => r.data);
export const saveOutreachSettings = (data: Record<string, any>) => api.put("/admin/outreach/settings", data).then((r) => r.data);
export const downloadOutreachPack = async (fmt: "pdf" | "csv") => {
  const res = await api.get(`/admin/outreach/pack.${fmt}`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = `AssortIQ_market_letters.${fmt}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

// Notifications
export const getNotifications = () => api.get("/notifications").then((r) => r.data);
export const markNotifRead = (id: string) => api.post(`/notifications/${id}/read`).then((r) => r.data);
export const markAllNotifRead = () => api.post("/notifications/read-all").then((r) => r.data);
